<template>
  <div class="document-container">
    <div>
      <router-view @reportCreated="appendReport"></router-view>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import 'vue-popperjs/dist/vue-popper.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight,
  faTimes,
  faCheck,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFilter,
  faMapMarkerAlt,
  faNotEqual,
  faSpinner,
  faArrowCircleDown,
  faClock,
  faSitemap,
} from '@fortawesome/pro-light-svg-icons';
import {
  faAngleRight as faAngleRightSolid,
  faTimes as faTimesSolid,
  faCheck as faCheckSolid,
  faCheckCircle as faCheckCircleSolid,
  faEdit as faEditSolid,
  faEllipsisH as faEllipsisHSolid,
  faFilter as faFilterSolid,
  faMapMarkerAlt as faMapMarkerAltSolid,
  faNotEqual as faNotEqualSolid,
  faSpinner as faSpinnerSolid,
  faArrowCircleDown as faArrowCircleDownSolid,
  faClock as faClockSolid,
  faSitemap as faSitemapSolid,
} from '@fortawesome/pro-solid-svg-icons';
import Popper from 'vue-popperjs';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';

import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

var ws;

library.add(
  faAngleRight,
  faTimes,
  faCheck,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFilter,
  faMapMarkerAlt,
  faNotEqual,
  faSpinner,
  faArrowCircleDown,
  faClock,
  faSitemap,
  faAngleRightSolid,
  faTimesSolid,
  faCheckSolid,
  faCheckCircleSolid,
  faEditSolid,
  faEllipsisHSolid,
  faFilterSolid,
  faMapMarkerAltSolid,
  faNotEqualSolid,
  faSpinnerSolid,
  faArrowCircleDownSolid,
  faClockSolid,
  faSitemapSolid,
);

export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  created() {
    this.setBreadcrumb([
      { text: 'Location Group', to: { name: 'groupList' } },
      { text: 'Reports', to: {} },
    ]);
  },
  components: {
    EsHeader,
    EsLoader,
    Popper,
  },
  data() {
    return {
      reportList: [],
      unfilteredreportList: [],
      status: '',
      reportType: '',
      delim: '',
      qual: '',
      loading: true,
      isSuccessGenerate: false,
      reporttypeidcheck: [],
      messages: [],
      selectedReport: null,
      reportTypes: {
        1: 'All Location Report',
        2: 'Location by Group with Hierarchy',
        3: 'Distinct Local Code Report',
        4: 'FNS-834 Report',
      },
      reportIcons: {
        1: 'map-marker-alt',
        2: 'sitemap',
        3: 'not-equal',
        4: 'landmark-alt',
      },
    };
  },
  methods: {
    appendReport(report) {
      this.unfilteredreportList.unshift(report);
      this.isSuccessGenerate = true;
      this.messages.push('The report is being generated. Go to My Activity panel to download the report when available.');
      this.showNotification('success', this.messages);
    },
    updateReportStatus(report) {
      const indexValue = this.findarrayindex(report);
      this.unfilteredreportList.splice(indexValue, 1, report);
      this.reportList = this.unfilteredreportList;
    },
    downloadReport(evt) {
      window.open(evt.target.href, '_blank');
    },
    buildUrl(id) {
      return `${axios.defaults.baseURL}reports/${id}/download`;
    },
    filterreportlist(reporttypeidvalues) {
      if (!(reporttypeidvalues.length < 1 || reporttypeidvalues === undefined)) {
        if (this.unfilteredreportList.length < 1
            || this.unfilteredreportList === undefined) {
          this.unfilteredreportList = this.reportList;
        }
        const tempreportList = (this.unfilteredreportList
          .filter(tempReport => (reporttypeidvalues
            .indexOf(`${tempReport.reportId}`) > -1)));
        this.reportList = tempreportList;
      } else {
        this.reportList = this.unfilteredreportList;
      }
    },
    findarrayindex(report) {
      const reportIdToFind = element => element.id === report.id;
      return this.unfilteredreportList.findIndex(reportIdToFind);
    },
  },
};
</script>

<style lang="sass" scoped>
  .text-muted
    color: #6c757d !important
  .activity-row
    border-top: 1px solid rgb(222, 226, 230)
  .activity-row-container
    padding: .5rem 1rem
    display: flex
  .icon-column
    min-width: 40px
    display: flex
    align-items: flex-start
  .activity-summary
    font-size: .85rem
    display: flex
    flex-direction: column
    align-items: flex-start
  .activity-element
    padding-top: 4px
    padding-bottom: 4px
    text-align: left
  .activity-status
    text-align: left
</style>
